import Image from "next/image";
import React, { useState } from "react";
// import Image from 'next/image'

export const set_size = (image, size = "1080x750", format = "webp", keep_original = false) => {
  if (!image) {
    return ("")
  }

  image = typeof image === "string" ? image : image.url;
  if (keep_original) {
    return image.replace(
      "https://storage.googleapis.com/listings-image",
      "https://images.agenz.ma"
    );
  }
  var re = /(?:\.([^.]+))?$/;
  var ext = re.exec(image)[1];
  if (ext) {
    if (ext === "jfif") {
      return image.replace(
        "https://storage.googleapis.com/listings-image",
        "https://images.agenz.ma"
      );
    }
    else if (ext.startsWith("com")) {

      return image.replace(
        "https://storage.googleapis.com/listings-image",
        "https://images.agenz.ma"
      );
    }
  }
  if (image) {
    if (image.includes("annonce-agenz")) {
      let url_split = image.split(`.${ext}`)[0];
      return `${url_split.replace(
        "https://storage.googleapis.com/listings-image",
        "https://images.agenz.ma"
      )}_${size}.webp`;
    } else if (image.includes("https://storage.googleapis.com")) {
      let url_split = image.split(`.${ext}`)[0];
      return `${url_split.replace(
        "https://storage.googleapis.com/listings-image",
        "https://images.agenz.ma"
      )}_${size}.${format == "webp" ? "webp" : ext}`;
    } else {

      return image.replace(
        "https://storage.googleapis.com/listings-image",
        "https://images.agenz.ma"
      );
    }
  }
  else {
    return "";
  }
};

export function ImageWithMultipleAspectRatios(props) {
  const [imageLoadFailed, setImageLoadFailed] = useState(false);

  if (imageLoadFailed) {
    return (
      <>
        {/* <img
          // layout="fill"
          width={350}
          height={177}
          fill={true}
          alt={props.alt}
          style={props.style}
          loading={props.loading}
          key={props.key}
          className={props.className}
          src={props.src}
          onError={({ currentTarget }) => {
            currentTarget.onerror = null; // prevents looping
            currentTarget.src = props.src
          }}
          /> */}
        <img
          width={350}
          height={177}
          fill={true}
          alt={props.alt}
          style={props.style}
          loading={props.loading}
          key={props.key}
          className={props.className}
          src={props.src}
          onError={({ currentTarget }) => {
            currentTarget.onerror = null; // prevents looping
            currentTarget.src = props.src
          }}
        />

      </>
    );
  }

  if (props.ommit250x250Resolution) {
    return (
      // <picture onError={() => setImageLoadFailed(true)}>
      //   <source
      //     media="(min-width:900px)"
      //     srcSet={set_size(props.src, "1080x750", "webp")}
      //   />
      //   <source
      //     media="(min-width:600px)"
      //     srcSet={set_size(props.src, "1080x750", "webp")}
      //   />
      //   <img
      //     alt={props.alt}
      //     style={props.style}
      //     loading={props.loading}
      //     key={props.key}
      //     className={props.className}
      //     src={set_size(props.src, "1080x750", "webp")}
      // onError={({ currentTarget }) => {
      //   currentTarget.onerror = null; // prevents looping
      //   currentTarget.src = props.src
      // }}
      //   />
      // </picture>
      // <img
      //   // layout="fill"
      //   width={350}
      //   height={177}
      //   alt={props.alt}
      //   style={props.style}
      //   loading={props.loading}
      //   key={props.key}
      //   className={props.className}
      //   src={set_size(props.src)}
      //   onError={({ currentTarget }) => {
      //     currentTarget.onerror = null; // prevents looping
      //     currentTarget.src = props.src
      //   }}
      //   />
      <img
        width={350}
        height={177}
        alt={props.alt}
        style={props.style}
        loading={props.loading}
        key={props.key}
        className={props.className}
        src={set_size(props.src)}
        onError={({ currentTarget }) => {
          currentTarget.onerror = null; // prevents looping
          currentTarget.src = props.src
        }}
      />
    );
  }

  return (

    // <img
    //   layout='fill'
    //   // objectFit='cover'
    //   width={250}
    //   height={177}
    //   alt={props.alt}
    //   style={props.style}
    //   loading={props.loading}
    //   key={props.key}
    //   className={props.className}
    //   src={set_size(props.src)}
    //   onError={({ currentTarget }) => {
    //     currentTarget.onerror = null; // prevents looping
    //     currentTarget.src = props.src
    //   }}
    //   />
    <img
      // layout='fill'
      // objectFit='cover'
      width={250}
      height={177}
      alt={props.alt}
      style={props.style}
      loading={props.loading}
      key={props.key}
      className={props.className}
      src={set_size(props.src)}
      onError={({ currentTarget }) => {
        currentTarget.onerror = null; // prevents looping
        currentTarget.src = props.src
      }}
    />
  );
}

const getImageToDisplay = (
  image,
  based_on_inner_width = true,
  width = 990,
  format = "webp"
) => {
  let w;
  if (based_on_inner_width) {
    if (window) {
      w = window.innerWidth;
    } else {
      w = width;
    }
  } else {
    w = width;
  }
  if (w < 300) {
    return set_size(image, "250x250", format);
  } else if (w < 600) {
    return set_size(image, "430x250", format);
  } else if (w < 900) {
    return set_size(image, "980x500", format);
  } else {
    return image;
  }
};

export default getImageToDisplay;
